function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.322 11.962h.063A3.61 3.61 0 0011.93 8.3a3.577 3.577 0 00-1.1-2.528 3.591 3.591 0 00-2.568-1.012A3.587 3.587 0 005.73 5.857a3.58 3.58 0 00-1.014 2.565 3.61 3.61 0 003.606 3.54"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M39.273 6.777C34.928 2.437 29.15.047 23.005.047a2.24 2.24 0 00-2.242 2.24 2.24 2.24 0 002.242 2.238c4.948 0 9.6 1.924 13.097 5.418 7.221 7.213 7.221 18.948 0 26.16a18.413 18.413 0 01-13.097 5.418A18.411 18.411 0 019.91 36.103a18.365 18.365 0 01-5.425-13.08 2.24 2.24 0 00-2.242-2.238A2.24 2.24 0 000 23.024C0 29.16 2.392 34.93 6.738 39.27 11.083 43.61 16.861 46 23.005 46c6.145 0 11.923-2.39 16.268-6.73 8.97-8.959 8.97-23.535 0-32.493z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c95bc9a9.svg";
export { ForwardRef as ReactComponent };